import fetch from './api'


// 获取批改任务分配列表
const GETCORRECTLISTZJ = params => {
  return fetch({
    url: '/api/admin/zjjk/getCorrectList',
    method: 'get',
    params
  })
}

// 点击分配获取批改老师列表
const GETCORRECTTEACHERLIST = params => {
  return fetch({
    url: '/api/admin/zjjk/getCorrectTeacherList',
    method: 'get',
    params
  })
}

// 分配/认领批改任务(支持批量)
const CORRECTASSIGN = params => {
  return fetch({
    url: '/api/admin/zjjk/correctAssign',
    method: 'post',
    params
  })
}




export default {
  GETCORRECTLISTZJ,
  GETCORRECTTEACHERLIST,
  CORRECTASSIGN
}





























// WEBPACK FOOTER //
// ./src/api/interface-distribute.js